import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from '../../../api/apiServises';
import { DEPARTMENTS, MODULE_ADD, ROLE_PERMISSIONS, ROLES, ROLESDELETE, ROLESTORE } from "../../../api/apiConstant";

const API_URL = "/api/roles";

export const fetchRoles = createAsyncThunk(
  "roles/fetchRoles",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get(ROLES);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch roles");
    }
  }
);
export const fetchDepartments = createAsyncThunk(
  "roles/fetchDepartments",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get(DEPARTMENTS);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch departments");
    }
  }
);


export const getRoleById = createAsyncThunk(
  "roles/getRoleById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.get(`${ROLES}/${id}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch role");
    }
  }
);

/* =============================
   CREATE ROLE
============================= */

export const createRole = createAsyncThunk(
  "roles/createRole",
  async (data, { rejectWithValue }) => {
    try {
      const res = await api.post(ROLESTORE, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Create role failed");
    }
  }
);

/* =============================
   UPDATE ROLE
============================= */

export const updateRole = createAsyncThunk(
  "roles/updateRole",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}/${id}`, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Update role failed");
    }
  }
);


export const deleteRole = createAsyncThunk(
  "roles/deleteRole",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.delete(`${ROLESDELETE}/${id}`);
      return { id, ...res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Delete failed");
    }
  }
);


export const fetchRolePermissions = createAsyncThunk(
  "roles/fetchRolePermissions",
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.get(`${ROLES}/${id}/permissions`);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch role permissions"
      );
    }
  }
);


export const updateRolePermission = createAsyncThunk(
  "roles/updateRolePermission",
  async (data, { rejectWithValue }) => {
    try {
      const res = await api.post(ROLE_PERMISSIONS, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update permission"
      );
    }
  }
);

export const createModule = createAsyncThunk(
  "roles/createModule",
  async (data, { rejectWithValue }) => {
    try {
      const res = await api.post(MODULE_ADD, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to create module"
      );
    }
  }
);